import type { TechniqueClass } from '../api/bookings'

/**
 * What to call a technique class on a chip (D-729).
 *
 * The style alone - "Ballet" - is what a teacher says. The level, or failing
 * that the class name, joins it only when she has two of one style that day,
 * so that the two chips can be told apart and no chip is longer than it needs
 * to be.
 */
export function techniqueLabel(one: TechniqueClass, all: TechniqueClass[]): string {
  const twins = all.filter((c) => c.style === one.style)
  if (twins.length < 2) return one.style
  return `${one.style} ${one.level ?? one.className}`
}
